import Rendering1 from "@/assets/images/3D/3d.png";
import LightingCoverageImg from "@/assets/images/lighting/lighting_cover.png";
import WifiCardImg from "@/assets/images/wifi/wifi.png";
import Lighting1 from "@/assets/images/lighting/Lighting.png";
import ArchFloorPlan from "@/assets/images/services/arch_floor_plan.png";
import StructuralElevationsSectionPlans from "@/assets/images/services/sturct_elevation.png";
import RcpPlans from "@/assets/images/services/rcp_plan.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";

export interface DraftingService {
  id: number;
  title: string;
  description: string;
  image: string;
  icon: string;
  tags: string[];
  disclaimer?: {
    label: string;
    description: string;
  };
}

export const draftingServices: DraftingService[] = [
  {
    id: 1,
    title: 'Architectural Floor Plans',
    description: 'Dimensionally precise plans that detail spatial layouts. We translate your design parameters into clean CAD files, ensuring structural component accuracy and accurate fixture placements based strictly on your provided sketches.',
    image: ArchFloorPlan,
    icon: 'ri-layout-grid-line',
    tags: ['CAD Conversion', 'Spatial Layouts', 'Dimensioning']
  },
  {
    id: 2,
    title: 'Structural Elevations & Sections',
    description: 'Detailed 2D vertical representations illustrating exterior facades and interior structural cutaways. We draft exact floor-to-ceiling heights, roof pitches, and exterior material callouts to provide your engineers with a flawless visual baseline for structural analysis.',
    image: StructuralElevationsSectionPlans,
    icon: 'ri-building-2-line',
    tags: ['Facade Drafting', 'Vertical Dimensions', 'Cross-Sections']
  },
  {
    id: 3,
    title: 'Reflected Ceiling Plans (RCP)',
    description: 'Highly coordinated overhead drafts mapping the exact placements of ceiling-mounted elements. We meticulously layer your lighting fixtures, HVAC diffusers, and sprinkler heads to help your team identify and resolve spatial clashes prior to installation.',
    image: RcpPlans,
    icon: 'ri-lightbulb-line',
    tags: ['MEP Coordination', 'Lighting Layouts', 'HVAC Placement']
  },
  {
    id: 4,
    title: '3D Photorealistic Renderings',
    description: 'High-quality 3D digital visualizations that transform your flat plans into immersive, textured environments. Ideal for allowing your clients to visually validate complex design and material choices.',
    image: Rendering1,
    icon: 'ri-image-2-line',
    tags: ['3D Modeling', 'Virtual Visualization', 'Material Texturing']
  },
  {
    id: 5,
    title: 'Line Diagrams & Schematics',
    description: 'Clear, easy-to-read single-line diagrams for complex low voltage (system design) and electrical systems. These plans are install ready for your technicians to begin working.',
    image: LineDiagram2,
    icon: 'ri-flow-chart',
    tags: ['Single-Line Diagrams', 'Electrical Routing', 'Plumbing Schematics']
  },
  {
    id: 6,
    title: 'Lighting Design & Analysis Layouts',
    description: 'Comprehensive drafting of lighting plans incorporating your specific fixture schedules and photometric data. We map out precise luminaire placements to support your overarching energy efficiency and illumination goals.',
    image: Lighting1,
    icon: 'ri-flashlight-line',
    tags: ['Fixture Schedules', 'Photometric Mapping', 'Illumination Plans']
  },
  {
    id: 7,
    title: 'WiFi & Network Coverage Plans',
    description: 'Detailed infrastructure drafts mapping low-voltage and networking layouts. We accurately plot wireless access points, server room routing, and signal strength zones to visualize your network engineering strategies.',
    image: WifiCardImg,
    icon: 'ri-wifi-line',
    tags: ['Low-Voltage Drafting', 'Access Point Mapping', 'Network Infrastructure']
  },
  {
    id: 8,
    title: 'Lighting Coverage & Illumination Maps',
    description: 'Highly detailed visual plots displaying calculated lux levels and illumination heat maps. We provide the visual drafting required for your team to easily verify that lighting coverage meets the intended environmental requirements.',
    image: LightingCoverageImg,
    icon: 'ri-sun-line',
    tags: ['Lux Level Mapping', 'Heat Maps', 'Visual Coverage Analysis']
  }
];
